'use client'

import React from 'react'
import SignArthaverse from './modules/auth/signArthaverse';
import Image from 'next/image';
import Link from 'next/link';
import { cx } from 'class-variance-authority';




function JoinArthavaVerseForm({ hide, profId }: { hide?: boolean, profId?: string }) {
    const img = '/artifacts.svg'

    return (
        <div className="w-full flex-1 overflow-hidden rounded-xl">
            <div className={cx("grid grid-cols-1 h-full", hide ? "grid-cols-1 w-full mx-auto" : " lg:grid-cols-2")}>

                {!hide && <div className='bg-[#375ED9] hidden lg:block'>
                    <div className='flex flex-col justify-between h-full'>

                        <Link href="/" className="block p-4">
                            <Image
                                src={"/arthaverse-white.svg"}
                                alt="ArthaVerse"
                                width={142}
                                height={35}
                                className="h-[35px] w-auto"
                            />
                        </Link>

                        <div className='flex flex-col justify-end'>
                            <Image
                                src={img}
                                alt="ArthaVerse"
                                width={500}
                                height={800}
                                className="w-full h-auto"
                            />
                        </div>

                    </div>
                </div>}



                {/* RIGHT FORM SECTION */}
                <SignArthaverse profId={profId || ""} />

            </div>
        </div>
    )
}




export default JoinArthavaVerseForm